import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import * as DocumentPicker from "expo-document-picker";
import {
	Actionsheet,
	Button,
	FormControl,
	Icon,
	IconButton,
	Input,
	Menu,
	Select,
	Stack,
	Text,
	useDisclose,
	useMediaQuery,
} from "native-base";
import React, { useEffect, useState } from "react";
import { Dimensions, View } from "react-native";
import api_comm from "../../common/lib";
import AppCamera from "../../components/camera/AppCamera";
import ContentArea from "../../components/ContentArea";
import ErrorToast from "../../components/ErrorToast";
import SuccessToast from "../../components/SuccessToast";
import { isWeb } from "../../utils/utils";

const StoreRegistration = ({ components, navigation }) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	let inputField = [];
	const [validated, setValidated] = useState(false);
	const [errors, setErrors] = useState({});
	const [files, setFiles] = useState(
		components?.children_components.filter((item) => {
			return item.sitepagecomponent_meta?.attributes?.type === "file";
		})
	);
	components?.children_components.map(({ datatype_name }) => {
		if (datatype_name !== undefined) {
			inputField[datatype_name] = "";
		}
	});

	const [StoreDetails, setStoreDetails] = useState(inputField);
	const [inputFields, setInputFields] = useState(inputField);
	// console.log('inputField', inputFields);
	const [isFormValid, setIsFormValid] = useState(false);
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const [loading, setLoading] = useState(false);
	const handlePressBrowseFile = async (datatype_name) => {
		let file = await DocumentPicker.getDocumentAsync({
			type: ["image/jpeg", "application/pdf", "image/png"],
		});

		setStoreDetails({ ...StoreDetails, [datatype_name]: file });
	};

	const { width, height } = Dimensions.get("window");
	const [imageField, setImageField] = useState("");
	const { isOpen, onOpen, onClose } = useDisclose();

	const handlePressSubmit = async () => {
		setIsSubmitting(true);
		// console.log('Submitting...', StoreDetails);
		let fileFields = files.map(({ datatype_name }) => datatype_name);
		// console.log(fileFields);
		const Body = new FormData();
		// re-initialize errors
		let formErrors = {};

		for (let key in StoreDetails) {
			if (StoreDetails[key] === "") {
				formErrors[key] = " is required";
			}
			if (!fileFields.includes(key)) {
				Body.append(key, StoreDetails[key]);
			}
		}
		for (let fileInput of fileFields) {
			// console.log('StoreDetails[fileInput]', StoreDetails[fileInput]);
			if (StoreDetails[fileInput]) {
				if (isWeb()) {
					Body.append(
						fileInput,
						StoreDetails[fileInput].file,
						StoreDetails[fileInput].name
					);
				} else {
					let File = {
						...StoreDetails[fileInput],
						type: StoreDetails[fileInput].mimeType,
					};

					Body.append(fileInput, File, StoreDetails[fileInput].name);
				}
			} else {
				formErrors[fileInput] = " file is required";
			}
		}
		// console.log('ERROR', errors);
		// console.log('ERROR', Object.keys(errors).length);
		if (Object.keys(formErrors).length > 0) {
			ErrorToast(
				Object.keys(formErrors)[0] +
					" " +
					formErrors[Object.keys(formErrors)[0]]
			);
			setIsSubmitting(false);
			setIsFormValid(false);
			return false;
		}

		// api_comm("post", "/members/api/v2/store/request", Body)
		// 	.then((response) => {
		// 		setStoreDetails([]);
		// 		SuccessToast("Store registered successfully", "Success");
		// 		// console.log(response);
		// 	})
		// 	.catch((err) => {
		// 		// const { data } = err;
		// 		// const { error, validation_issue } = data;
		// 		// console.log("ERR::", data);
		// 		// console.log("ERR 1::", error);
		// 		// console.log("validation_issue 1::", validation_issue);
		// 		// let errors = "";

		// 		// if (Object.keys(validation_issue)?.length > 0) {
		// 		// 	for (let issue in validation_issue) {
		// 		// 		console.log(issue);
		// 		// 		errors += issue + " \n";
		// 		// 	}
		// 		// }
		// 		console.log("handlePressSubmit -> ", err);
		// 		// ErrorToast(errors, error);
		// 	});

		try {
			let response = await api_comm(
				"post",
				"/members/api/v2/store/request",
				Body
			);

			if (response.data.result) {
				setStoreDetails([]);
				setIsSubmitting(false);
				SuccessToast("Store registered successfully", "Success");
				navigation.navigate("Store Registration");
			}
		} catch (err) {
			setIsSubmitting(false);
			if (err.data) {
				const { data } = err;
				const { error, validation_issue } = data;
				console.log("ERR::", data);
				console.log("ERR 1::", error);
				console.log("validation_issue 1::", validation_issue);
				let errors = "";

				if (Object.keys(validation_issue)?.length > 0) {
					for (let issue in validation_issue) {
						errors += issue + " \n";
					}
				}
				ErrorToast(errors, error);
			} else {
				ErrorToast(err.message);
			}
		}
	};

	const onChange = (value, label = null) => {
		if (value.target?.files) {
			StoreDetails({
				...StoreDetails,
				[value.target.name]: value.target.files[0],
			});
		} else if (label == "Store" || label == "Role" || label == "Gender") {
			const description = value; // TODO: FIND

			setStoreDetails({
				...StoreDetails,
				[label]: { value, description },
			});
		} else {
			setStoreDetails({
				...StoreDetails,
				[label]: value,
			});
		}
	};

	const onCapture = (photo, datatype_name) => {
		let date = new Date().toISOString().substring(0, 10).split("-").join("");
		let time = new Date().toISOString().substring(11, 19).split(":").join("");
		let img = {
			...photo,
			mimeType: "application/jpg",
			name: `IMG_${date}_${time}.jpg`,
		};
		// console.log(img);
		let currentStoreDetails = StoreDetails;
		currentStoreDetails[imageField] = img;
		setStoreDetails(currentStoreDetails);
		onClose();
	};

	return (
		<ContentArea>
			<FormControl isRequired>
				<Stack mx="4" space={2.5} padding={isDesktopOrLaptop[0] ? "10" : null}>
					{components?.children_components.map((control, index) => {
						switch (control.componenttype_name) {
							case "INPUT":
								if (
									control.sitepagecomponent_meta.options &&
									control.datatype_name === "franchisee_guid"
								) {
									return (
										<View key={control.sitepagecomponent_guid}>
											<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
											<Select
												onValueChange={(value) =>
													onChange(value, control.datatype_name)
												}
												name={`${control.datatype_name}`}
												placeholder={` Select ${control.datatype_label}...`}
												selectedValue={
													StoreDetails[control.datatype_name]?.name
												}
											>
												{control.sitepagecomponent_meta.options
													?.filter((value) => {
														if (!StoreDetails["franchiseegroup_guid"])
															return value;

														if (
															value?.relations?.channel?.guid ===
															StoreDetails["franchiseegroup_guid"]
														) {
															return value;
														}
													})
													.map((option, index) => {
														if (option.value) {
															return (
																<Select.Item
																	key={index}
																	label={option.value}
																	value={option.key}
																/>
															);
														} else {
															return (
																<Select.Item
																	key={index}
																	label={option}
																	value={option}
																/>
															);
														}
													})}
											</Select>
										</View>
									);
								} else if (
									control?.sitepagecomponent_meta?.options &&
									control?.sitepagecomponent_meta?.options?.length > 0
								) {
									return (
										<View key={control.sitepagecomponent_guid}>
											<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
											<Select
												onValueChange={(value) =>
													onChange(value, control.datatype_name)
												}
												name={`${control.datatype_name}`}
												placeholder={` Select ${control.datatype_label}...`}
												selectedValue={
													StoreDetails[control.datatype_name]?.name
												}
											>
												{control.sitepagecomponent_meta.options?.map(
													(option, index) => {
														if (option.value) {
															return (
																<Select.Item
																	key={index}
																	label={option.value}
																	value={option.key}
																/>
															);
														} else {
															return (
																<Select.Item
																	key={index}
																	label={option}
																	value={option}
																/>
															);
														}
													}
												)}
											</Select>
										</View>
									);
								} else if (control.sitepagecomponent_meta.attributes) {
									if (
										control.sitepagecomponent_meta.attributes.type === "file"
									) {
										return (
											<View key={control.sitepagecomponent_guid}>
												<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
												<View
													style={{
														justifyContent: "space-around",
													}}
												>
													{/* {isWeb() ? (
														<Button
															key={control.sitepagecomponent_guid}
															// bgColor={colors.primary}
															style={
																isDesktopOrLaptop[0]
																	? {
																			marginRight: "auto",
																			marginLeft: "auto",
																	  }
																	: {}
															}
															onPress={() => {
																setImageField(control.datatype_name);
																handlePressBrowseFile(control.datatype_name);
															}}
															leftIcon={
																<Icon
																	as={Ionicons}
																	name="cloud-upload-outline"
																	size="sm"
																/>
															}
														>
															Upload
														</Button>
													) : (
														<Menu
															key={control.sitepagecomponent_guid}
															width={150}
															alignItems="center"
															trigger={(triggerProps) => {
																return (
																	<Button
																		{...triggerProps}
																		// onPress={() => setShowPopover(true)}
																		style={
																			isDesktopOrLaptop[0]
																				? {
																						marginRight: "auto",
																						marginLeft: "auto",
																				  }
																				: {}
																		}
																		leftIcon={
																			<Icon
																				as={Ionicons}
																				name="cloud-upload-outline"
																				size="sm"
																			/>
																		}
																	>
																		Upload
																	</Button>
																);
															}}
														>
															<Menu.Item
																onPress={() => {
																	onOpen();
																	setImageField(control.datatype_name);
																}}
															>
																Take Photo
															</Menu.Item>
															<Menu.Item
																onPress={() => {
																	setImageField(control.datatype_name);
																	handlePressBrowseFile(control.datatype_name);
																}}
															>
																Choose File
															</Menu.Item>
														</Menu>
													)} */}
													{isWeb() ? (
														<>
															<Button
																// bgColor={colors.primary}
																key={control.sitepagecomponent_guid}
																style={
																	isDesktopOrLaptop[0]
																		? {
																				marginRight: "auto",
																				marginLeft: "auto",
																		  }
																		: {}
																}
																onPress={() => {
																	setImageField(control.datatype_name);
																	handlePressBrowseFile(control.datatype_name);
																}}
																leftIcon={
																	<Icon
																		as={Ionicons}
																		name="cloud-upload-outline"
																		size="sm"
																	/>
																}
															>
																Upload
															</Button>
															<Text color="primary.300">
																{StoreDetails[control.datatype_name]?.name}
															</Text>
														</>
													) : (
														<Input
															key={control.sitepagecomponent_guid}
															name={`${control.datatype_label}`}
															value={StoreDetails[control.datatype_name]?.name}
															isReadOnly={true}
															multiline={true}
															numberOfLines={2}
															type="text"
															padding="2"
															placeholder={control.datatype_label}
															InputRightElement={
																<IconButton
																	onPress={() => {
																		onOpen();
																		setImageField(control.datatype_name);
																	}}
																	size="md"
																	_icon={{
																		as: MaterialIcons,
																		name: "camera-alt",
																		color: "primary.500",
																		size: "md",
																	}}
																/>
															}
															InputLeftElement={
																<IconButton
																	onPress={() => {
																		setImageField(control.datatype_name);
																		handlePressBrowseFile(
																			control.datatype_name
																		);
																	}}
																	size="md"
																	_icon={{
																		as: MaterialIcons,
																		name: "photo",
																		color: "primary.500",
																		size: "md",
																	}}
																/>
															}
														/>
													)}
												</View>
											</View>
										);
									} else if (
										control.sitepagecomponent_meta.attributes.type === "submit"
									) {
										// console.log('HERE');
										return (
											<>
												<Button
													key={control.sitepagecomponent_guid}
													isLoading={isSubmitting}
													isLoadingText="Submitting"
													variant={isSubmitting ? "outline" : "solid"}
													key={control.sitepagecomponent_guid}
													style={[
														{ marginTop: 20 },
														isDesktopOrLaptop[0]
															? {
																	// marginRight: "auto",
																	marginLeft: "auto",
															  }
															: {},
													]}
													onPress={() => handlePressSubmit()}
													rightIcon={
														<Icon
															as={Ionicons}
															name="chevron-forward-outline"
															size="md"
														/>
													}
												>
													Submit
												</Button>
											</>
										);
									}
									//
								} else {
									let controlType = "text";
									let showHelper = false;
									if (
										control.datatype_label.toLowerCase().includes("cellphone")
									) {
										showHelper = true;
									}
									if (control.datatype_label.toLowerCase().includes("email")) {
										controlType = "email";
									} else if (
										control.datatype_label.toLowerCase().includes("password")
									) {
										controlType = "password";
									}
									return (
										<View key={control.sitepagecomponent_guid}>
											<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
											<Input
												onChangeText={(value) =>
													onChange(value, control.datatype_name)
												}
												secureTextEntry={
													controlType == "password" ? true : false
												}
												placeholder={`${control.datatype_label}`}
												label={`${control.datatype_label}`}
											/>
											{control.sitepagecomponent_meta.input_notice && (
												<FormControl.HelperText _text={{ fontSize: "xs" }}>
													{control.sitepagecomponent_meta.input_notice}
												</FormControl.HelperText>
											)}
										</View>
									);
								}

							default:
								break;
						}
					})}
				</Stack>
			</FormControl>
			<Actionsheet isOpen={isOpen} onClose={onClose}>
				<Actionsheet.Content style={{ height: height / 1.3 }}>
					<AppCamera onClose={onClose} onCapture={onCapture} base64={false} />
				</Actionsheet.Content>
			</Actionsheet>
		</ContentArea>
	);
};

export default StoreRegistration;
